import { z } from 'zod';
import { E164, Id, Timestamp, VerticalKey } from './common.js';
import { Email, Membership, Role } from './auth.js';

export const Vertical = z.object({
  id: Id,
  key: VerticalKey,
  name: z.string().min(1),
  profile: z.record(z.unknown()),
});
export type Vertical = z.infer<typeof Vertical>;

export const User = z.object({
  id: Id,
  email: Email,
  name: z.string().min(1),
  phone: E164.nullable(),
  active: z.boolean(),
  memberships: z.array(Membership),
  createdAt: Timestamp,
});
export type User = z.infer<typeof User>;

export const InviteUserRequest = z
  .object({
    email: Email,
    name: z.string().trim().min(1).max(120),
    phone: E164.optional(),
    verticalIds: z.array(Id).min(1),
    /** 'admin' also makes the user an org admin (may invite and change memberships). Least privilege by default. */
    role: Role.default('member'),
  })
  .strict();
export type InviteUserRequest = z.infer<typeof InviteUserRequest>;

export const InviteUserResponse = z.object({ user: User, inviteExpiresAt: Timestamp });
export type InviteUserResponse = z.infer<typeof InviteUserResponse>;

export const SetMembershipsRequest = z.object({ verticalIds: z.array(Id) }).strict();
export type SetMembershipsRequest = z.infer<typeof SetMembershipsRequest>;
